import React, { useState } from "react";
import AdminTopbar from "../../component/AdminTopbar";
import { BarChart, Calendar, ChevronRight, ChevronsLeft, Edit2, Filter, Home, Plus, Share, Trash2 } from "react-feather";

const initialTasks = [
  {
    id: 1,
    name: "Public Beta Release",
    assignedTo: "https://randomuser.me/api/portraits/men/32.jpg",
    deadline: "14 Mar 2023",
    status: "Ongoing",
    completion: "10/10",
    priority: "High",
  },
  {
    id: 2,
    name: "Fix Platform Errors",
    assignedTo: "https://randomuser.me/api/portraits/men/33.jpg",
    deadline: "12 Feb 2023",
    status: "Completed",
    completion: "9/10",
    priority: "High",
  },
  {
    id: 3,
    name: "Launch our Mobile App",
    assignedTo: "https://randomuser.me/api/portraits/men/34.jpg",
    deadline: "10 Mar 2023",
    status: "Ongoing",
    completion: "8/10",
    priority: "High",
  },
];


function AdminTodoListPage() {
  const [tasks, setTasks] = useState(initialTasks);
  const [filter, setFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [newTask, setNewTask] = useState({
    name: "",
    assignedTo: "",
    deadline: "",
    priority: "High",
  });

  const removeTask = (id) => {
    setTasks((prev) => prev.filter((task) => task.id !== id));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTask((prev) => ({ ...prev, [name]: value }));
  };

  const addTask = () => {
    if (!newTask.name || !newTask.assignedTo || !newTask.deadline || !newTask.priority) return;

    const newId = tasks.length > 0 ? Math.max(...tasks.map((t) => t.id)) + 1 : 1;
    const formattedDeadline = new Date(newTask.deadline).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const taskToAdd = {
      ...newTask,
      id: newId,
      deadline: formattedDeadline,
      status: "Ongoing",
      completion: "0/10",
    };

    setTasks((prev) => [...prev, taskToAdd]);
    setNewTask({ name: "", assignedTo: "", deadline: "", priority: "High" });
  };

  const filteredTasks = tasks.filter((task) => {
    const matchesFilter = filter === "All" || task.status === filter;
    const matchesSearch = task.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });
  
    return (

      <>
      <AdminTopbar/>


<div className="text-end breadcrumb1 px-5 align-items-center d-flex justify-content-end mt-2">
  <span><Home size={14}/></span>
  <span><ChevronRight size={14}/></span>
  <span>My Tasks</span> 
</div>

      
      <div className="container  mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h2 className="chart-title text-start">My Tasks</h2>
              <p>List of your ongoing projects</p>
            </div>
            <div className="d-flex align-items-center">
              {/* <div className="me-3">
                <Filter />
              </div> */}
              <div>
                <button className="new-project-btn" >
                  <Plus />
                  &nbsp;New Project
                </button>
              </div>
            </div>
          </div>

      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <table className="table cus-table align-middle mb-0 table-bordered">
            <thead className="bg-light table__head">
              <tr>
                <th className="text-start">Task Name</th>
                <th>Assigned</th>
                <th>Deadline</th>
                <th>Status</th>
                <th>Completion</th>
                <th>Priority</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTasks.map((task) => (
                <tr key={task.id} className="border-top">
                  <td className="text-start py-3 px-4">
                    <input type="checkbox" className="form-check-input me-2" />
                    {task.name}
                  </td>
                  <td>
                    <img
                      src={task.assignedTo}
                      alt="User"
                      className="rounded-circle"
                      width="32"
                      height="32"
                    />
                  </td>
                  <td>{task.deadline}</td>
                  <td>
                    <span className={`badge rounded-pill ${task.status === "Completed" ? "bg-light text-dark border" : "bg-success text-white"}`}>
                      {task.status}
                    </span>
                  </td>
                  <td>{task.completion}</td>
                  <td>
                    <span className="mk1">{task.priority}</span>
                  </td>
                  <td className="text-start">
                    <div className="dropdown">
                      <button
                        className="btn btn-sm btn-outline-secondary  "
                        type="button"
                        id={`dropdownMenuButton${task.id}`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                         <BarChart size={15}/>
                      </button>
                      <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${task.id}`}>
                        <li>
                          <button className="dropdown-item dd1">
                           <Share size={15}/>&nbsp;
                            Share
                          </button>
                        </li>
                        <li>
                          <button className="dropdown-item dd1">
                          <Edit2 size={15}/>&nbsp;
                            Rename
                          </button>
                        </li>
                        <li>
                          <button className="dropdown-item dd1" onClick={() => removeTask(task.id)}>
                          <Trash2 size={15}/>&nbsp;
                            Remove
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

 {/* Add Task Modal */}
      <div className="modal fade" id="addTaskModal" tabIndex="-1" aria-labelledby="addTaskModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addTaskModalLabel">Add New Task</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label text-start d-block">Task Name</label>
                  <input type="text" name="name" className="form-control" placeholder="Enter task name" value={newTask.name} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label text-start d-block">Assigned To</label>
                  <input type="text" name="assignedTo" className="form-control" placeholder="Enter image URL" value={newTask.assignedTo} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label text-start d-block">Deadline</label>
                  <input type="date" name="deadline" className="form-control" value={newTask.deadline} onChange={handleInputChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label text-start d-block">Priority</label>
                  <select name="priority" className="form-select" value={newTask.priority} onChange={handleInputChange}>
                    <option>High</option>
                    <option>Medium</option>
                    <option>Low</option>
                  </select>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={addTask}>Save Task</button>
            </div>
          </div>
        </div>
      </div>
  
    </>
    );
  }

export default AdminTodoListPage